<template>
    <span
        class="text-sm text-tertiary"
        data-spec-class="card_list-subtitle"
    >
        <slot></slot>
    </span>
</template>
